import Glitter from '../movies/glitter.mp4';

export default function Pusher() {

    return (

        <div className="horizontal-push">
            <video autoPlay muted loop playsInline>
                <source src={Glitter} type="video/mp4" />
                Brak obsługi wideo przez Twoją przeglądarkę :-(
            </video>
        </div>

    )    

}